/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/home/HomeIndividual.css";
import { useTranslation } from "react-i18next";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { DateRangePicker, DateInput } from "@progress/kendo-react-dateinputs";
import HourPicker from "./HourPicker";
import { BsInfo } from "react-icons/bs";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Checkbox, TextBox } from "@progress/kendo-react-inputs";
import fetchClient from "../../axios/fetch";
import {
  format,
  add,
  intervalToDuration,
  areIntervalsOverlapping,
  parseISO,
} from "date-fns";

const HomeIndividual = ({ setIsBooking, setErrorMessage }) => {
  let Navigate = useNavigate();
  const { t } = useTranslation();
  const auth = useSelector((state) => state.auth);
  const tooltip = useRef(null);
  const tooltip1 = useRef(null);
  const tooltip2 = useRef(null);
  const unavailableObj = useRef({});
  const officeTrigger = useSelector((state) => state.reload.office);
  const countryTrigger = useSelector((state) => state.reload.country);
  // useStates
  const [daylongState, setDaylongState] = useState(false);
  const [roomName, setRoomName] = useState([]);
  const [seats, setSeats] = useState([]);
  const [multiSeat, setMultiSeat] = useState([]);
  const [roomValue, setRoomValue] = useState({});
  const [errors, setErrors] = useState({});
  const [resetTrigger, setResetTrigger] = useState(false);
  const [hourHolder, setHourHolder] = useState({
    start: null,
    end: null,
  });
  const [officeHours, setOfficeHours] = useState([]);
  // const [currentOfficehrs, setCurrentOfficehrs] = useState({
  //   start: null,
  //   end: null,
  // });
  const [officeDuration, setOfficeDuration] = useState(0);
  const [lockOfficeDates, setlockOfficeDates] = useState([]);
  const [bookedDates, setBookedDates] = useState([]);
  const [dateValue, setDateValue] = useState({
    start: null,
    end: null,
  });
  const [openDatePicker, setOpenDatePicker] = useState(false);
  // For bulleted form text (2 lines )
  const TooltipContentTemplate = (props) => {
    return (
      <ul className="attendeeTooltip">
        <li>{props.title1}</li>
        <li>{props.title2}</li>
      </ul>
    );
  };
  const [hour, setHour] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);

  let entity = localStorage.getItem("entity") === '0' ? null : Number(localStorage.getItem("entity"));

  const [payload, setPayload] = useState({
    Id: 0,
    usersId: auth.user.id,
    startBookingDate: "",
    endBookingDate: "",
    startBookingTime: "",
    endBookingTime: "",
    seatNumber: [0],
    internalParticipant: "",
    externalParticipant: "",
    capacity: 0,
    reason: "",
    areaType: 1,
    areaId: 0,
    roomName: "",
    link: "",
    officeName: "",
    status: "Active",
    entityId: entity,
  });

  const min = new Date();
  const max = new Date(2090, 12, 31);

  useEffect(() => {
    getOffice();
    getRoomName();
    const datepickers = document.querySelectorAll(".k-daterangepicker");
    datepickers.forEach((datepicker) =>
      datepicker.addEventListener("keydown", (e) => {
        if (
          e.keyCode === 37 ||
          e.keyCode === 38 ||
          e.keyCode === 39 ||
          e.keyCode === 40 ||
          e.keyCode === 8
        ) {
          e.preventDefault();
          e.stopPropagation();
        }
      })
    );
  }, []);

  useEffect(() => {
    getOffice();
    getRoomName();
    setRoomValue({
      roomName: t("select"),
    });
    setPayload({ ...payload, areaId: 0, seatNumber: [0], internalParticipant: "" });
    setMultiSeat([]);
  }, [officeTrigger, countryTrigger]);

  useEffect(() => {
    getOfficeLockDisableDates();
    getDisabledDates();
    setPayload((prevState) => ({
      ...prevState,
      startBookingDate: null,
      endBookingDate: null,
    }));
    setDateValue({
      start: null,
      end: null,
    });
  }, [payload.seatNumber]);

  useEffect(() => {
    adjustDateTime();
    setErrorMessage("");
    setResetTrigger(!resetTrigger);
    setPayload((prevState) => ({
      ...prevState,
      startBookingTime: "",
      endBookingTime: "",
    }));
  }, [dateValue]);

  useEffect(() => {
    setErrors(validate());
  }, [payload]);

  useEffect(() => {
    if (!roomName.roomValue) {
      setRoomValue({
        roomName: t("select"),
      });
      setErrorMessage("");
    }
  }, [t]);

  const getDisabledDates = () => {
    if (payload.seatNumber[0] !== 0 || payload.seatNumber.length > 0) {
      fetchClient()
        .get(
          `api/booking/${payload.seatNumber.toString()}/${payload.areaId}/${localStorage.getItem("office")}`
        )
        .then((res) => setBookedDates(res.data.data));
      // old //.then((res) => setDisabledDates(res.data.data));
      // .catch((err) => console.log(err));
    }
  };

  const handleDaylongChange = () => {
    setDaylongState(!daylongState);
    setErrorMessage("");
    if (!daylongState) {
      setHourHolder({
        start: payload.startBookingTime,
        end: payload.endBookingTime,
      });
      setPayload({
        ...payload,
        startBookingTime: "00:00:00",
        endBookingTime: "00:00:00",
      });
    } else {
      setPayload({
        ...payload,
        startBookingTime: hourHolder.start,
        endBookingTime: hourHolder.end,
      });
    }
  };

  const setTime = (start, end) => {
    setPayload({ ...payload, startBookingTime: start, endBookingTime: end });
  };

  const CustomStartDateInput = (props) => {
    return (
      <label>
        <DateInput {...props} label={`*${t("start_date")}`} />
      </label>
    );
  };

  const CustomEndDateInput = (props) => {
    return (
      <label>
        <DateInput {...props} label={`*${t("end_date")}`} />
      </label>
    );
  };

  const getRoomName = () => {
    if (!localStorage.getItem("office") || !localStorage.getItem("entity")) {
      setRoomName([]);
      return;
    }

    fetchClient()
      .get(`/api/booking/rooms/${localStorage.getItem("office")}/1/${localStorage.getItem("entity")}`)
      .then((res) => {
          const sortedRooms = res.data.data.sort((a, b) =>
              a.roomName.localeCompare(b.roomName)
          );
          setRoomName(sortedRooms);
      });
    // .catch((err) => {
    //   console.log(err);
    // });
  };

  const getSeat = (areaId) => {
    fetchClient()
      .get("api/booking/seat/" + areaId)
      .then((res) => {
        let holdSeatsArray = [];
        res.data.data.map((e) => {
          let hold = {
            id: e.id,
            seatNumber: e.seatNumber.toString(),
          };
          holdSeatsArray.push(hold);
        });
        setSeats(holdSeatsArray);
      });
    // .catch((err) => {
    //   console.log(err);
    // });
  };

  const adjustDateTime = () => {
    setPayload({
      ...payload,
      startBookingDate:
        dateValue.start !== null ? format(dateValue.start, "yyyy-MM-dd") : null,
      endBookingDate:
        dateValue.end !== null ? format(dateValue.end, "yyyy-MM-dd") : null,
    });
    if (dateValue.start !== null && dateValue.end !== null) {
      getTime(
        format(new Date(dateValue.start), "yyyy-MM-dd"),
        format(new Date(dateValue.end), "yyyy-MM-dd")
      );
    }


  };

  const getOffice = async () => {
    try {
      if (!localStorage.getItem("office"))
        return;

      const res = await fetchClient().get(`api/entity/office/${localStorage.getItem("office")}`);
      const fetchedEntities = res?.data?.data || [];

      if (fetchedEntities.length === 0) {
        localStorage.setItem("entity", "0");
      }

      await fetchClient()
        .get("api/office/" + localStorage.getItem("office"))
        .then((res) => {
          var holdTime = [
            1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
            1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
            1, 1,
          ];

          const startHourHolder = res.data.data.startOfficeHour.slice(0, 2);
          const startMinHolder = res.data.data.startOfficeHour.slice(3, 5);
          const endHourHolder = res.data.data.endOfficeHour.slice(0, 2);
          const endMinHolder = res.data.data.endOfficeHour.slice(3, 5);
          // const startTime = res.data.data.startOfficeHour.split(":");
          // const endTime = res.data.data.endOfficeHour.split(":");
          for (
            let index =
              (parseInt(startHourHolder) + (startMinHolder === "00" ? 0 : 0.5)) *
              2;
            index <
            parseInt(endHourHolder) * 2 - 1 + (endMinHolder === "00" ? 1 : 2); // Just to display the exact end time range in hour picker(removed the 30 mins excess)
            index++
          ) {
            holdTime[index] = 0;
          }


          const now = new Date();
          const startOfficeHour = res.data.data.startOfficeHour.slice(0, 8); // Extracting time string
          const endOfficeHour = res.data.data.endOfficeHour.slice(0, 8);

          // Parsing and constructing valid date objects
          const startDate = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            parseInt(startOfficeHour.split(":")[0]), // Hours
            parseInt(startOfficeHour.split(":")[1]), // Minutes
            parseInt(startOfficeHour.split(":")[2]) // Seconds
          );
          const endDate = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            parseInt(endOfficeHour.split(":")[0]), // Hours
            parseInt(endOfficeHour.split(":")[1]), // Minutes
            parseInt(endOfficeHour.split(":")[2]) // Seconds
          );

          const durationObj = intervalToDuration({
            start: startDate,
            end: endDate,
          });
          //This function is to show available working hours at the daylong
          // setCurrentOfficehrs({
          //   start: format(
          //     new Date(
          //       now.getYear(),
          //       now.getMonth(),
          //       now.getDay(),
          //       startTime[0],
          //       startTime[1],
          //       startTime[2]
          //     ),
          //     "p"
          //   ),
          //   end: format(
          //     new Date(
          //       now.getYear(),
          //       now.getMonth(),
          //       now.getDay(),
          //       endTime[0],
          //       endTime[1],
          //       endTime[2]
          //     ),
          //     "p"
          //   ),
          // });  // This is for Daylong to get the Available working hrs values
          setOfficeDuration(durationObj.hours + durationObj.minutes / 60);
          setOfficeHours(holdTime);
          setHour(holdTime);
          // console.log(res.data.data);
        });
      // .catch((err) => console.log(err));

    } catch (err) {
      setErrorMessage(err.response.data);
    }
  };


  const bookIndividual = () => {
    setIsBooking(true);
    let officeName;
    let newPayload;
    fetchClient()
      .get("api/office/" + localStorage.getItem("office"))
      .then((res) => {
        if (daylongState) {
          newPayload = {
            ...payload,
            startBookingTime: res.data.data.startOfficeHour.slice(0, 8),
            endBookingTime: res.data.data.endOfficeHour.slice(0, 8),
            officeId: localStorage.getItem("office"),
            entityId: entity,
          };
        } else {
          newPayload = {
            ...payload,
            officeId: localStorage.getItem("office"),
            entityId: entity,
          };
        }
        officeName = res.data.data.officeName;
        fetchClient()
          .post("/api/booking", newPayload)
          .then((res) => {
            const now = new Date();
            const startTime = newPayload.startBookingTime.split(":");
            const endTime = newPayload.endBookingTime.split(":");
            const eventStartTime = new Date(
              now.getYear(),
              now.getMonth(),
              now.getDay(),
              startTime[0],
              startTime[1],
              startTime[2]
            );
            const eventEndTime = new Date(
              now.getYear(),
              now.getMonth(),
              now.getDay(),
              endTime[0],
              endTime[1],
              endTime[2]
            );

            // eventEndTime.setMinutes(eventEndTime.getMinutes() + 1);
            fetchClient()
              .get(`api/reminder/${localStorage.getItem("office")}`)
              .then((res) => {
                const serverData = res.data.data;
                newPayload = {
                  ...payload,
                  link:
                    serverData.link && serverData.isEnable
                      ? serverData.link
                      : "",
                };
              })
              .catch((err) => {
                // console.log(err);
                newPayload = {
                  ...payload,
                  link: "",
                };
              })
              .finally(() => {

                const startBookingDate = parseISO(newPayload.startBookingDate);
                const endBookingDate = parseISO(newPayload.endBookingDate);



                Navigate("/bookSuccessful", {
                  state: {
                    payload: newPayload,
                    date:
                      format((startBookingDate), "PP") +
                      " - " +
                      format((endBookingDate), "PP"),
                    time:
                      format(eventStartTime, "p") +
                      " - " +
                      format(eventEndTime, "p"),
                    type: newPayload.areaType,
                    officeName: officeName,
                    room: newPayload.areaId,
                    link: newPayload.link,
                    intParticipants: newPayload.internalParticipant,
                  },
                });
              });
            setIsBooking(false);
            setErrorMessage("");
          })
          .catch((err) => {
            if (err.response.status === 400) {
              setErrorMessage(err.response.data);
            }
            setIsBooking(false);
          });
      });
  };

  const getTime = (start, end) => {
    let seatItem = payload.seatNumber.toString();
    if (seatItem) {
      fetchClient()
        .get(
          `/api/booking/${seatItem}/${start}/${end}/${localStorage.getItem(
            "office"
          )}/0`
        )
        .then((result) => {
          const returnHour = result.data?.data?.hour || [];
          const baseHours = officeHours.length > 0 ? officeHours : new Array(returnHour.length).fill(0);
          const newHour = baseHours.map((slot, index) => (returnHour[index] === 1 ? 1 : slot));

          setHour(newHour);
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  };

  const checkEmail = () => {
    const pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const arr = payload.internalParticipant
      .split(";")
      .map((email) => email.trim());
    for (let i = 0; i < arr.length; i++) {
      if (!arr[i].match(pattern)) {
        return true;
      }
    }
    return false;
  };

  const validate = () => {
    const error = {};
    if (!payload.roomName) {
      error.roomName = true;
    }
    if (payload.areaId === 0) {
      error.areaId = true;
    }
    if (payload.seatNumber[0] === 0 || payload.seatNumber.length === 0) {
      error.seats = true;
    }
    if (!payload.startBookingDate) {
      error.startBookingDate = true;
    }
    if (!payload.endBookingDate) {
      error.endBookingDate = true;
    }
    if (!daylongState && !payload.startBookingTime) {
      error.startBookingTime = true;
    }
    if (!daylongState && !payload.endBookingTime) {
      error.endBookingTime = true;
    }

    const internalParticipants = payload.internalParticipant
      .split(";")
      .filter((email) => email.trim() !== "").length;

    if (multiSeat.length < internalParticipants.length) {
      error.internalParticipants = true;
    }
    if (multiSeat.length !== internalParticipants + 1) {
      error.internalParticipants = true;
    }

    if (internalParticipants !== 0)
      if (checkEmail()) {
        error.email = true;
      }
    return error;
  };

  //Get AreRestriction if Lock whole office is True in the selected Office
  const getOfficeLockDisableDates = () => {
    fetchClient()
      .get("api/seatcapacity/restrictions/" + localStorage.getItem("office"))
      .then((res) => {
        const seatData = res.data.data.map((item) => ({
          ...item,
          startDate: `${item.startRestrictionDate}`,
          endDate: `${item.endRestrictionDate}`,
          startTime: `${item.startRestrictionHour}`,
          endTime: `${item.endRestrictionHour}`,
        }));
        const blockedSpecificDate = seatData.map((item) => ({
          endDate: format(new Date(item.endDate), "MM-dd-yyyy"),
          endTime: item.endTime,
          startDate: format(new Date(item.startDate), "MM-dd-yyyy"),
          startTime: item.startTime,
        }));
        //console.log(blockedSpecificDate);
        setlockOfficeDates(blockedSpecificDate);
      })
    //.catch((err) => console.log(err));
  };

  //new checking of disable dates
  const disableDates = () => {
    const dateObj = {};

    // Disable a specific date in the Start and End Date calendar.
    const disableSpecificDateSeats = [
      { // Disable for the month of OCT
        endDate: "10-31-2023",
        endTime: "18:00:00",
        startDate: "10-02-2023",
        startTime: "09:00:00",
      },
      { // Disable for the month of NOV
        endDate: "11-30-2023",
        endTime: "18:00:00",
        startDate: "11-01-2023",
        startTime: "09:00:00",
      },
      { // Disable for the month of DEC
        endDate: "12-29-2023",
        endTime: "18:00:00",
        startDate: "12-01-2023",
        startTime: "09:00:00",
      },
    ];
    // Set specific Room and Seats and apply the dates above to disable
    if (roomValue.roomName === "Coaster" && (payload.seatNumber.includes(30) || payload.seatNumber.includes(38))) {
      disableSpecificDateSeats.map((item) => {
        bookedDates.unshift(item);
      });
    }
    // Blocked Specific dates for Holidays
    // const blockedSpecificDate = [
    //   {
    //     endDate: "10-30-2023",
    //     endTime: "18:00:00",
    //     startDate: "10-30-2023",
    //     startTime: "09:00:00",
    //   },
    //   {
    //     endDate: "11-02-2023",
    //     endTime: "18:00:00",
    //     startDate: "11-01-2023",
    //     startTime: "09:00:00",
    //   },
    //   {
    //     endDate: "11-27-2023",
    //     endTime: "18:00:00",
    //     startDate: "11-27-2023",
    //     startTime: "09:00:00",
    //   },
    // ];
    // Apply the blocked dates
    // lockOfficeDates.map((item) => {
    //    bookedDates.unshift(item);
    //  });

    lockOfficeDates.map((item) => {
      bookedDates.unshift(item);
    });

    // Merged the unavailable dates from the DB
    bookedDates.forEach((data) => {
      //get time duration object using date-nfs
      const durationObj = intervalToDuration({
        start: new Date(`${data.startDate}, ${data.startTime}`),
        end: new Date(`${data.endDate}, ${data.endTime}`),
      });
      //calculate time duration
      const duration = durationObj.hours + durationObj.minutes / 60;

      //get number of days inbetween the start & end date
      const numberOfDays = intervalToDuration({
        start: new Date(data.startDate),
        end: new Date(data.endDate),
      }).days;

      //if booked on the same date
      if (numberOfDays === 0) {
        // check if date array is already on the dateObj
        if (dateObj.hasOwnProperty(`${data.startDate}`)) {
          dateObj[`${data.startDate}`].push(duration);
        } else {
          // add if not
          dateObj[`${data.startDate}`] = [duration];
        }
      } else {
        // booked on a date range
        let currentDate = format(new Date(data.startDate), "MM-dd-yyyy");
        let i = 0;
        // loop through all the booked dates within the range
        do {
          // check if date array is already on the dateObj
          if (dateObj.hasOwnProperty(`${currentDate}`)) {
            dateObj[`${currentDate}`].push(duration);
          } else {
            // add if not
            dateObj[`${currentDate}`] = [duration];
          }
          currentDate = format(add(new Date(currentDate), { days: 1 }), "MM-dd-yyyy");
          i++;
        } while (i <= numberOfDays);
      }
    });

    const disabled = [];

    for (const date in dateObj) {
      const totalOccupied = dateObj[date].reduce((acc, curr) => acc + curr, 0);

      if (officeDuration > 0 && totalOccupied >= (officeDuration - 0.1)) {
        const curDate = format(new Date(date), "EEEE, LLLL d, yyyy");
        disabled.push(curDate);

        const cells = document.querySelectorAll(`td[title="${curDate}"]`);
        cells.forEach(cell => {
          cell.classList.add("k-disabled");
          cell.setAttribute("aria-disabled", "true");
          cell.classList.remove("k-today", "k-calendar-today", "k-actual-today");
          cell.style.pointerEvents = "none";
          cell.style.backgroundColor = "#f7f7f7";
          cell.style.color = "#cecece";
          cell.style.boxShadow = "none";
          cell.style.border = "none";
        });
      }
    }
    unavailableObj.current = disabled;
  };


  return (
    <>
      <div
        className="dropdown-room-name dropdown col-12 col-md-6 col-lg-3 align-self-end mb-5 p-0 px-md-3"
        onFocus={() => {
          const dates = document.querySelectorAll(".k-dateinput .k-input-inner");
          dates.forEach((date) => date.setAttribute("readonly", true));
          setTimeout(disableDates, 50);
          setOpenDatePicker(false);
        }}
      >
        <p>*{t("room_name")}</p>
        <DropDownList
          className="room-name"
          data={roomName}
          value={roomValue}
          textField="roomName"
          onChange={(e) => {
            setMultiSeat([]);
            getSeat(e.target.value.id);
            setRoomValue(e.target.value);
            setPayload({
              ...payload,
              seatNumber: [0],
              internalParticipant: "",
              areaId: e.target.value.id,
              roomName:
                e.target.value.roomName.charAt(0).toUpperCase() +
                e.target.value.roomName.slice(1),
            });
          }}
        />
      </div>
      <div
        className={`dropdown-seats dropdown col-12 col-md-6 col-lg-3 align-self-end mb-5 p-0 px-md-3`}
      >
        <div className="d-flex align-items-center gap-2">
          <p>*{t("seat_number")}</p>
          <div
            className="radio-tooltip"
            onMouseOver={(event) =>
              tooltip2.current && tooltip2.current.handleMouseOver(event)
            }
            onMouseOut={(event) =>
              tooltip2.current && tooltip2.current.handleMouseOut(event)
            }
          >
            <BsInfo
              className="info-btn"
              title={t("seat_tooltip")}
            />
            <Tooltip
              className="hour-daylong"
              ref={tooltip2}
              anchorElement="target"
              position="top"
              openDelay={100}
            />
          </div>
        </div>
        <MultiSelect // Enable this for MultiSelect function
          className="seat-number"
          data={seats}
          value={multiSeat}
          onChange={(e) => {
            var hold = [];
            var seatItem = [];
            e.value.map((element) => {
              hold.push(element.id);
              seatItem.push(element);
            });
            setMultiSeat(seatItem);
            setPayload({ ...payload, seatNumber: hold, capacity: multiSeat.length });
            if (seatItem.length === 0) {
              setPayload({
                ...payload,
                internalParticipant: "",
              });
              setOpenDatePicker(false);
            }
          }}
          textField="seatNumber"
          dataItemKey="id"
          placeholder={t("select")}
          disabled={payload.areaId === 0}
          onFocus={() => {
            setOpenDatePicker(false);
          }}
        />
      </div>

      {/* Change the multiselect into DropDownList to pick just 1 seat */}
      {/* <DropDownList
        className="seat-number"
        data={seats}
        value={multiSeat[0]} // The value prop is set to multiSeat[0] since the dropdown expects a single selected value.
        onChange={(e) => {
          // the onChange sets selectedSeat to e.target.value if a seat is selected, or null if no seat is chosen.
          const selectedSeat = e.target.value || null;
          setMultiSeat([selectedSeat]); //Then, it updates the multiSeat state with the selected seat and sets the payload.seatNumber.
          setPayload({
            ...payload,
            seatNumber: selectedSeat ? [selectedSeat.id] : [],
          });
        }}
        textField="seatNumber"
        dataItemKey="id"
        placeholder={t("select")}
        disabled={payload.areaId === 0} // End for 1 seat restriction
      />
    </div > */}

      <div
        className={
          "date-range-picker col-12 col-lg-6 align-self-end mb-5 p-0 px-md-3"
        }>

        <DateRangePicker
          show={openDatePicker}
          className="book-daterangepicker"
          startDateInput={CustomStartDateInput}
          endDateInput={CustomEndDateInput}
          value={dateValue}
          min={min}
          max={max}
          disabled={multiSeat.length === 0 ? true : false}
          onFocus={() => {
            // new
            const dates = document.querySelectorAll(".k-dateinput .k-input-inner");
            const calendars = document.querySelectorAll(".k-calendar");
            dates.forEach((date) => date.setAttribute("readonly", true));
            calendars.forEach((calendar) =>
              calendar.addEventListener("mousemove", disableDates)
            );
            setTimeout(disableDates, 100);
            setOpenDatePicker(true);
          }}
          onChange={(e) => {
            // check if the selected date overlaps with the disabled dates
            const noOverlaps = unavailableObj.current.every((date) => {
              if (e.target.value.end !== null) {
                const isOverlapping = areIntervalsOverlapping(
                  {
                    start: e.target.value.start,
                    end: e.target.value.end,
                  },
                  {
                    start: new Date(date),
                    end: new Date(date),
                  }
                );
                // break loop if it overlaps
                return isOverlapping ? false : true;
              }
            });
            setDateValue({
              start: e.target.value.start,
              end:
                e.target.value.end < // check if date is within a month
                  add(e.target.value.start, { months: 1 }) && noOverlaps
                  ? e.target.value.end // if yes, set e.target.value as the end date
                  : null,
            });
          }}
          onBlur={() => {
            setOpenDatePicker(false);
          }}
        // show={true}
        />
      </div>

      <div
        className="time-daylong col-12 col-lg-6 row p-0 px-md-3 mb-5 mb-lg-0 ">
        <div className="hour-time col-6 align-self-end ps-0 px-md-3 ">
          <HourPicker
            defaultValue={t("select")}
            disabled={daylongState || payload.areaId === 0}
            time={hour}
            resetTrigger={resetTrigger}
            handleTime={setTime}
            mobile={true}
          />
        </div>
        <div className="hour-daylong col-6 align-self-end px-3">
          <div className="d-flex d-flex align-items-center gap-2">
            <Checkbox
              className="radio-daylong d-flex align-items-center"
              label={t("daylong")}
              onChange={handleDaylongChange}
              onFocus={() => {
                setOpenDatePicker(false);
              }}
            />
            <div
              className="radio-tooltip"
              onMouseOver={(event) =>
                tooltip.current && tooltip.current.handleMouseOver(event)
              }
              onMouseOut={(event) =>
                tooltip.current && tooltip.current.handleMouseOut(event)
              }
            >
              <BsInfo
                className="info-btn"
                title={t("day1")}
              />
              <Tooltip
                className="hour-daylong"
                ref={tooltip}
                // content={(props) => (
                //   <TooltipContentTemplate
                //     title1={t("day1")}
                //     title2={`${currentOfficehrs.start} - ${currentOfficehrs.end}`}
                //   />
                // )}
                anchorElement="target"
                position="top"
                openDelay={100}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="textbox col-12 col-md-3 col-lg-3 mb-5 mb-md-0 p-0 px-md-3 ">
        <div className="d-flex">
          <p>{t("additional_internal_participant")}</p>
          <div
            className="radio-tooltip"
            onMouseOver={(event) =>
              tooltip1.current && tooltip1.current.handleMouseOver(event)
            }
            onMouseOut={(event) =>
              tooltip1.current && tooltip1.current.handleMouseOut(event)
            }
          >
            <BsInfo className="info-btn" title={"title"} />
            <Tooltip
              ref={tooltip1}
              content={(props) => (
                <TooltipContentTemplate title1={t("pod1")} title2={t("pod2")} />
              )}
              anchorElement="target"
              position="top"
              openDelay={100}
            />
          </div>
        </div>
        <TextBox
          className="add-internal"
          placeholder={t("email")}
          value={payload.internalParticipant}
          onChange={(e) => {
            setPayload({ ...payload, internalParticipant: e.target.value });
          }}
          onFocus={() => {
            setOpenDatePicker(false);
          }}
        />
      </div>

      <div
        className={"col-12 col-lg-3 d-flex justify-content-md-end p-0 px-md-3 "}
      >
        <button
          className="booking-btn"
          onClick={() => {
            bookIndividual();
          }}
          disabled={Object.keys(errors).length !== 0}
        >
          <span>{t("book")}</span>
        </button>
      </div>
    </>
  );
};

export default HomeIndividual;
